import { IS_BEFORE_REGISTER_TIME, IS_REGISTER_PERIOD } from "@/constants/env"

export const offlinePageLoader = async () => {
  if (IS_BEFORE_REGISTER_TIME || IS_REGISTER_PERIOD) return {}

  throw new Response("Not Found", { status: 404 })
}
